import { render, staticRenderFns } from "./BankInfo.vue?vue&type=template&id=023d20b3&scoped=true&"
import script from "./BankInfo.vue?vue&type=script&lang=js&"
export * from "./BankInfo.vue?vue&type=script&lang=js&"
import style0 from "./BankInfo.vue?vue&type=style&index=0&id=023d20b3&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "023d20b3",
  null
  
)

export default component.exports